import waRequest from './wa-request';

export const apiBase = '/access-points/v1';

/**
 * Initiate authenticated POST ${apiBase}/access-points/searches
 *
 * @returns {Promise}
 */
function getAccessPointLocationsConfigPattern({
  params: {organizationId, page = 0, size = 25, sort, locale} = {},
  data: {personId, dateStart, dateEnd} = {},
  signal,
} = {}) {
  const url = `${apiBase}/access-points/searches`;

  return waRequest.requestAuthenticated({
    url,
    method: 'post',
    signal,
    params: {
      organizationId,
      page,
      size,
      sort,
      locale,
    },
    data: {
      personId,
      dateStart,
      dateEnd,
    },
  });
}

export default {
  getAccessPointLocationsConfigPattern,
};
